<template>
	<button
		class="site_button"
		type="submit"
		value="Submit"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		:style="{ '--site-button-colour': button_colour, '--min-height' : minHeight + 'px', '--border-thickness': borderThickness + 'px' }"
		:class="{ 'no-border': border === 'no' }"
		ref="site_button"
	>
		<span v-html="button_label ? button_label : 'Submit'"></span>
	</button>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			hovered: false,
			button_colour: this.colour.replace('"', ''),
		};
	},

	props: {
		label: {},
		colour: {
			default: '#000',
		},
		border: {
			default: 'yes',
		},
		minHeight: {
			default: '40',
		},
		borderThickness: {
			default: '1',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.site_button {
	border: 1px solid $cpmec-green;
	padding: 0 $spacer * 2;
	display: grid;
	grid-template-columns: 1fr;
	justify-content: flex-start;
	align-items: center;
	min-height: var(--min-height);
	max-width: calc(100% - 82px);
	width: auto;
	text-decoration: none;
	column-gap: $spacer;
	appearance: none;
	border: 0;
	color: $cpmec-blue;
	font-size: 20px;
	background: $cpmec-green;
	border: 1px solid $cpmec-green;
	transition: 0.2s ease all;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 5px 5px rgba(#000, 0.5);
		transition: 0.2s ease all;
	}


	@media (max-width: $lg) {
		width: 100%;
	}

	&.no-border {
		border: 0px solid transparent;
		padding: 0 $spacer;
		max-width: calc(100% - 40px);
		column-gap: 0;

		span {
			padding-bottom: $spacer / 2;
			border-bottom: var(--border-thickness) solid var(--site-button-colour);
		}
	}

	&:hover {
		cursor: pointer;
	}

	span {
		color: var(--site-button-colour);
		font-size: 20px;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteButtonSubmit.vue